var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.elevators)?_c('donut',{attrs:{"data":_vm.chartData,"pie":_vm.pie,"centerText":_vm.chartCenterText},on:{"segment-click":_vm.onSegmentClick}}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-499314e6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/ElevatorsStatusChartSimple.vue
// module id = 766
// module chunks = 0